/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_5fffde50',
  textField: 'textField_5fffde50',
  eventWithLabel: 'eventWithLabel_5fffde50',
  eventWithoutLabel: 'eventWithoutLabel_5fffde50',
};

export = styles;

loadStyles([{"rawString":".root_5fffde50{box-sizing:border-box;box-shadow:none;margin:0;padding:0;margin-bottom:17px}.textField_5fffde50{position:relative}.textField_5fffde50 input::-ms-clear{display:none}.textField_5fffde50 input[readonly]{cursor:pointer}.eventWithLabel_5fffde50{color:"},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":";font-size:20px;line-height:20px;pointer-events:none;position:absolute;bottom:5px}[dir=ltr] .eventWithLabel_5fffde50{right:9px}[dir=rtl] .eventWithLabel_5fffde50{left:9px}.eventWithoutLabel_5fffde50{color:"},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":";font-size:20px;line-height:20px;pointer-events:none;position:absolute;top:7px}[dir=ltr] .eventWithoutLabel_5fffde50{right:9px}[dir=rtl] .eventWithoutLabel_5fffde50{left:9px}"}]);
/* tslint:enable */